import { createSlice } from '@reduxjs/toolkit'
import { defaultTo } from 'ramda'

const slice = createSlice({
  name: 'dtSignalOverviewValues',
  initialState: {},
  reducers: {
    setDtSignalOverviewValues: (state, { payload }) => {
      state[`${payload.id}`] = {
        ...defaultTo({}, state[`${payload.id}`]),
        [payload.signalModelId]: {
          data: payload.data,
        }
      }
    },
  },
})

export const { setDtSignalOverviewValues } = slice.actions

export default slice.reducer

export const selectDtSignalOverviewValues = (id) => (state) =>
  state.dtSignalOverviewValues[id]
